import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loading from "../../Loading";
import Error from "../../components/Error";
import useDB from "../../hooks/useDB";
import Lang from "../../components/Lang";
import useDBO from "../../hooks/useDBO";
import Text from "../../components/Text";
import BookList from "../../components/BookList";
import mut from "../../hooks/mut";
import { TextField } from "@mui/material";
import Info from "../../components/Info";
import ProgressHT from "../../components/ProgressHT";
import Plural from "../../components/Plural";


export default function Syllabus({syllabuses}) {
    const { syllabus } = useParams();
    const [syl, setSyl, error, loading] = useDB(`/get-syllabus/${syllabus}`)
    if (loading) return <Loading />
    if(error) return <Error />
 

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          paddingTop: 10,
        }}
      >
        <div style={{ display: "flex", gap: 20 }}>
          <Text
            value={syl.name}
            setValue={(name) => setSyl({ ...syl, name })}
            url={`/update-syllabus/${syl._id}`}
            field="name"
            label={<Lang w="name" />}
            size="small"
            style={{ flexGrow: 1 }}
          />
           <Link to={`/syllabus-missing/${syl._id}`}>
          <Info
            title={`Percent completed ${parseInt(syl.percentComplete) || 0}%`}
            body={<ProgressHT value={syl.percentComplete} />}
          />
            </Link>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <BookList
            syllabus={syl}
            setSyllabus={setSyl}
            style={{ flexGrow: 1 }}
          />
          <div>
            <div
              style={{
                textAlign: "center",
                border: "1px solid #ccc",
                padding: 5,
                borderRadius: 5,
                height: "100%",
              }}
            >
              Ages
              <div style={{ marginTop: 5 }}>
                <Text
                  value={syl.ageFrom}
                  setValue={(ageFrom) => setSyl({ ...syl, ageFrom })}
                  url={`/update-syllabus/${syl._id}`}
                  field="ageFrom"
                  type="number"
                  label="From"
                  size="small"
                  style={{ width: 80 }}
                  align="center"
                />{" "}
                -{" "}
                <Text
                  value={syl.ageTo}
                  setValue={(ageTo) => setSyl({ ...syl, ageTo })}
                  url={`/update-syllabus/${syl._id}`}
                  field="ageTo"
                  type="number"
                  label="To"
                  size="small"
                  style={{ width: 80 }}
                  align="center"
                />
              </div>
            </div>
          </div>
          
        </div>
        <Units
          syllabus={syl}
          syllabuses={syllabuses}
        />
        <div>General information</div>
        {general.map((g) => (
          <Text
            value={syl[g.name]}
            setValue={(val) => ({ ...syl, [g.name]: val })}
            label={g.label}
            url={`/update-syllabus/${syl._id}`}
            field={g.name}
            /*  multiline={g.multiline}
          rows={g.rows} */
            size="small"
          />
        ))}
      </div>
    );
}


function Units({ syllabus, syllabuses }) {
    
    const [name,setName] = useState("")
  const units = useDBO(`/units/${syllabus._id}`)
  const navigate = useNavigate()

  if (units.loading) return <loading />
  
      const checkKey = async (e) => {
        if (e.keyCode === 13 && name.length>0) {
         let res = await mut("put", "/add-unit/", {
            syllabus: syllabus._id,
            name
         });
          units.add(res)
          let newSyllabus = { ...syllabus }
          newSyllabus.units.push(res)
          syllabuses.update(newSyllabus)
          setName("")
        }
      }

    return (
      <div>
        <Lang w="units" />

        <div style={{ marginBottom: 10 }}>
          {units.get.length > 0 ? (
            units.get.map((unit) => (
              <div
                key={unit._id}
                className="lesson-button"
                onClick={() =>
                  navigate(
                    `/teaching/syllabus/${syllabus._id}/unit/${unit._id}`
                  )
                }
              >
                {/*  <Link
                          to={`/teaching/syllabus/${unit.syllabus._id}/unit/${unit._id}/lesson/${lesson._id}`}
                          className="neat"
                        > */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 20,
                  }}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      background: unit.issues > 0 ? "#ffd6db" : "white",
                    }}
                  >
                    Unit {unit.unitNumber} - {unit.name}{" "}
                    {unit.issues && unit.issues > 0 && unit.issues > 0
                      ? ` - ${unit.issues} issue${unit.issues > 2 ? "s" : ""}`
                      : ""}
                  </div>
                  <div style={{ width: 150, textAlign: "left" }}>
                    {unit.lessons.length} lesson
                    <Plural value={unit.lessons.length} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      color: "#888",
                      fontSize: 12,
                      width: 130,
                      marginRight: 10,
                    }}
                  >
                    <div style={{ width: 100 }}>
                      <ProgressHT value={unit.percentComplete} />
                    </div>
                    <div style={{ width: 20, textAlign: "center" }}>
                      {parseInt(unit.percentComplete) || 0}%
                    </div>
                  </div>
                </div>
                {/*  </Link> */}
              </div>
            ))
          ) : (
            <div>No units</div>
          )}
        </div>
        <TextField
          value={name}
          onChange={(e) => setName((prev) => e.target.value)}
          label={<Lang w="addANewUnit" />}
          size="small"
          sx={{ width: 600 }}
          onKeyUp={checkKey}
        />
      </div>
    );
    
}

const general = [
  { name: "CEFR", label: "Đầu ra theo CEFR" },
  { name: "addOnPackages", label: "Gói bổ trợ", multiline: true, rows:3 },
  { name: "trainingModel", label: "Mô hình đào tạo" },
  { name: "careModel", label: "Mô hình chăm sóc" },
  { name: "commitment", label: "Cam kết đồng hành" },
  { name: "benefitsOfTheCourse", label: "Lợi ích từ khóa học" },
];